module.exports = __webpack_public_path__ + "1910537f323312c90b3c281eae22df40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tea-cups-s.png
// module id = 2134
// module chunks = 0